// client/src/components/web/WebChatPage.jsx
// Página standalone servida en /iframe/:companyId/:channelId. Es lo que carga el
// iframe interno del widget embebible (widget.js). Ocupa todo el iframe.
import { useParams } from 'react-router-dom';
import WebChatWidget from './WebChatWidget';

export default function WebChatPage() {
  const { companyId, channelId } = useParams();
  return <WebChatWidget companyId={companyId} channelId={channelId} variant="page" />;
}
